import moment from 'moment'
import ft from '../featureToggle'

export default {
  getLogs (VueApp, corporateId, callback) {
    let corporate = VueApp.$store.state.corporate.logs
    VueApp.$sdk.get('/admin/corporateprofile/' + corporateId + '/logs', {
      token: VueApp.$store.state.session.sessionToken,
      order: corporate.order,
      orderAsc: corporate.orderAsc,
      pageNum: corporate.currentPage,
      pageSize: corporate.perPage
    }, res => {
      if (!res.error) {
        let logs = []
        let infoLog = {}
        res.list.forEach(function (data) {
          infoLog = {
            id: data.id,
            action: data.action,
            created: moment.tz(data.created, 'YYYY-MM-DD@HH:mm:ss@@@@', "GMT").tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm:ss'),
            admin: data.admin ? {
              name: `${data.admin.firstName} ${data.admin.lastName}`,
              id: data.admin.id,
              email: data.admin.email,
              phone: data.admin.phone
            } : null,
            collapsed: false
          }
          switch (data.action) {
            default: logs.push({
              ...infoLog
            })
              break
            case 'update':
              let fields = []
              if (data.details.changes) {
                data.details.changes.forEach(function (data2) {
                  fields.push({
                    field: data2.field,
                    old: data2.old,
                    new: data2.new
                  })
                })
                logs.push({
                  ...infoLog,
                  fields
                })
              } else {
                logs.push({
                  ...infoLog
                })
              }
              break

            case 'update_invoice':
            case 'create_invoice':
              let invoice = data.details.result.list[0]
              logs.push({
                ...infoLog,
                invoiceId: invoice.id,
                file: invoice.fileUrl,
                status: invoice.status,
                startDate: moment(invoice.startDate).format('MM/DD/YYYY'),
                endDate: moment(invoice.endDate).format('MM/DD/YYYY'),
                dueDate: moment(invoice.dueDate).format('MM/DD/YYYY')
              })
          }
        })
        logs.forEach(log => VueApp.$store.commit('corporate/addCorporateLog', log))
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/corporate/logs.js